import React from 'react';
import { Layout } from 'react-admin';
import { LayoutAppBar } from './AppBar';

export const AppLayout = props => <Layout {...props} appBar={LayoutAppBar} />;